import type {
  DevModeLifecycleHookEvent,
  DevModeSchemaType,
  DevModeSnippetExample
} from '@cli-types/next-adapter/generators.js'
import { SAMPLE_UUID } from '@cli-constants/generators.js'
import { createExample } from './create-example.js'
import { lifecycleHookPhase } from './lifecycle-hook-phase.js'
import { sampleAdminUserSummary } from './sample-admin-user-summary.js'
export function lifecycleHookContextExample(
  event: DevModeLifecycleHookEvent,
  schemaName: string,
  input: Record<string, unknown>,
  data: Record<string, unknown>,
  schemaType: DevModeSchemaType = 'entity'
): DevModeSnippetExample {
  const phase = lifecycleHookPhase(event)
  const context: Record<string, unknown> = {
    user: sampleAdminUserSummary(),
    entityType: schemaName,
    timestamp: '2026-01-01T00:00:00.000Z'
  }

  if (schemaType === 'form') {
    context.schemaType = 'form'
  }
  if (event === 'beforeRestore' || event === 'afterRestore') {
    context.entityId = SAMPLE_UUID
    context.changedFields = []
    context.metadata = { restoredFromVersion: 2 }
    if (phase === 'after') {
      context.data = data
    }
    return createExample('Context', context)
  }
  if (event === 'beforeReorder' || event === 'afterReorder') {
    context.changedFields = ['sortOrder']
    if (phase === 'after') {
      context.data = { order: [{ id: SAMPLE_UUID, sortOrder: 0 }] }
    }
    return createExample('Context', context)
  }
  if (event !== 'beforeCreate' && event !== 'afterCreate') {
    context.entityId = SAMPLE_UUID
  }
  if (phase === 'before' && !event.endsWith('Delete')) {
    context.input = event.endsWith('Publish')
      ? { ...input, published: true }
      : event.endsWith('Unpublish')
        ? { published: false }
        : input
  }
  if (phase === 'after' && !event.endsWith('Delete')) {
    context.entityId = SAMPLE_UUID
    context.data = data
  }

  return createExample('Context', context)
}
